"use client";
import { FeatureFlagComponentResolverClient } from "@/lib/feature-flags/FeatureFlagResolverClient";
import MonarchResolver from "@/monarch/MonarchResolver";
import type { AbandonedCartTestResult } from "@/monarch/rules/abandonedCart/types";
import AbandonedCartTestComponent from "./AbandonedCartTest";

interface AbandonedCartTestProps {
  defaultContent: string;
  defaultUrl?: string;
  defaultIcon?: string;
  className?: string;
  cartData?: {
    items: Array<{
      id: number;
      courseName: string;
      price: number;
      originalPrice?: number;
      quantity: number;
      discount?: number;
    }>;
    subtotal: number;
    discounts: Array<{
      type: "percentage" | "fixed";
      value: number;
      description: string;
    }>;
    total: number;
    tax: number;
    shipping: number;
  };
}

export default function AbandonedCartTest({
  defaultContent,
  defaultUrl,
  defaultIcon,
  className,
  cartData,
}: AbandonedCartTestProps) {
  return (
    <FeatureFlagComponentResolverClient
      flagKey="NEXT_PUBLIC_FEATURE_ABANDONED_CART_TEST"
      variants={{
        legacy: null,
        test: (
          <MonarchResolver<AbandonedCartTestResult>
            experimentKey="useAbandonedCart"
            variants={{
              control: null,
              test: <AbandonedCartTestComponent className={className} />,
            }}
            Loader={null}
          />
        ),
      }}
      fallback="legacy"
    />
  );
}
